import { Typography } from '@mui/material'

function GridProceedingsStatus({
  status,
  variant = 'body1',
  component = 'div',
  className = '',
}) {
  const statusMap = {
    p: { label: 'Pendiente autorización', colorClass: 'text-error' },
    s: {
      label: 'Pendiente aprobación para acreditación',
      colorClass: 'text-error',
    },
    a: { label: 'Acreditado', colorClass: 'text-success' },
    w: { label: 'Acreditación pendiente', colorClass: 'text-error' },
    r: { label: 'Rechazado', colorClass: 'text-error' },
  }

  return (
    <Typography
      variant={variant}
      component={component}
      className={`${statusMap?.[status]?.colorClass || ''} ${className}`}
    >
      {statusMap?.[status]?.label || status}
    </Typography>
  )
}

export default GridProceedingsStatus
